import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, message } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";

const { Item: ItemForm } = Form;
const { Column } = Table;
const ButtonGroup = Button.Group;



export default class MonitorProducaoForm extends Component {
  state = {
    registro: {
      op_idf: 0,
      pi_dt_producao: moment().format('DD/MM/YYYY'),
      pi_dt_entrega: moment().format('DD/MM/YYYY'),
      pis_status: { key: 0, label: '' },
      tipo: '',
      checkDTProducao: false,
      checkDTEntrega: false,
      checkStatus: false,
      checkOBS: false,
    },

    carregandoForm: false,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {

      });
    }
  }

  componentDidMount() {
    this.buscaStatus();
  }

  onOK = () => {

    if (this.state.registro.tipo === 'GRUPO') {
      if ((!this.state.registro.pi_dt_producao) || (!moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY', true).isValid())) {
        Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
        return;
      }

      const registro = {
        tipo: this.state.registro.tipo,
        pi_item: this.state.registro.pi_item,
        pi_seq: this.state.registro.pi_seq,
        pi_dt_producao: this.state.checkDTProducao ? moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        pi_dt_entrega: this.state.checkDTEntrega ? moment(this.state.registro.pi_dt_entrega, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        pis_status: this.state.checkStatus ? this.state.registro.pis_status.key : '',
        pi_obs: this.state.checkOBS ? this.state.registro.pi_obs : '',
        listaProducao: this.state.registro.listaProducao
      };

      axios.put(`/producao/updateMonitor/0`, registro)
        .then(response => {
          this.props.onCancelarClick();
          message.success('Data alterada com sucesso');
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        })

    } else if (this.state.registro.tipo === 'DP') {
      if ((!this.state.registro.pi_dt_producao) || (!moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY', true).isValid())) {
        Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
        return;
      }

      const registro = {
        tipo: this.state.registro.tipo,
        pi_item: this.state.registro.pi_item,
        pi_seq: this.state.registro.pi_seq,
        pi_dt_producao: moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };

      axios.put(`/producao/updateMonitor/${this.state.registro.op_idf}`, registro)
        .then(response => {
          this.props.onCancelarClick();
          message.success('Data alterada com sucesso');
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        })

    } else if (this.state.registro.tipo === 'DE') {
      if ((!this.state.registro.pi_dt_entrega) || (!moment(this.state.registro.pi_dt_entrega, 'DD/MM/YYYY', true).isValid())) {
        Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
        return;
      }

      const registro = {
        tipo: this.state.registro.tipo,
        pi_item: this.state.registro.pi_item,
        pi_seq: this.state.registro.pi_seq,
        pi_dt_entrega: moment(this.state.registro.pi_dt_entrega, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };

      axios.put(`/producao/updateMonitor/${this.state.registro.op_idf}`, registro)
        .then(response => {
          this.props.onCancelarClick();
          message.success('Data alterada com sucesso');
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        })

    } else if (this.state.registro.tipo === 'TDP') {
      if ((!this.state.registro.pi_dt_producao) || (!moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY', true).isValid())) {
        Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
        return;
      }

      const registro = {
        tipo: this.state.registro.tipo,
        lp_idf: this.state.registro.lp_idf,
        pi_dt_producao_todas: moment(this.state.registro.pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };

      axios.put(`/producao/updateMonitor/0`, registro)
        .then(response => {
          this.props.onCancelarClick();
          message.success('Data alterada com sucesso');
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        })

    } else if (this.state.registro.tipo === 'OBS') {
      if ((!this.state.registro.pi_obs) || (this.state.registro.pi_obs === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe a Observação' });
        return;
      }

      const registro = {
        tipo: this.state.registro.tipo,
        pi_item: this.state.registro.pi_item,
        pi_seq: this.state.registro.pi_seq,
        pi_obs: this.state.registro.pi_obs,
      };

      axios.put(`/producao/updateMonitor/${this.state.registro.op_idf}`, registro)
        .then(response => {
          this.props.onCancelarClick();
          message.success('Observação alterada com sucesso');
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        })

    } else if (this.state.registro.tipo === 'ST') {
      if ((!this.state.registro.pis_status) || (this.state.registro.pis_status.key === '0') || (this.state.registro.pis_status.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Status', });
        return;
      }

      const reg = {
        pis_item: this.state.registro.pi_item,
        pis_seq: this.state.registro.pi_seq,
        pis_status: this.state.registro.pis_status.key,
        pis_obs: ''
      }

      axios
        .put(`/producao/updateStatus/${this.state.registro.op_idf}`, reg)
        .then(response => {
          this.props.onCancelarClick();
          message.success('Status alterado com sucesso');
        }).catch(error => {
          console.error(error.response);
          this.setState({ carregando: false })
        })

    }


  };


  buscaStatus = (value) => {
    this.setState({ statusSelect: [] })
    axios.get('/statusProducao/lista')
      .then(response => {
        const { data } = response;
        const statusSelect = data.map(regList => {
          return {
            key: regList.sp_idf,
            label: regList.sp_descricao,
          }
        });
        this.setState({
          statusSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };


  // ----------------------------------------------------------------


  renderValor = (valor) => {
    return (
      <span> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }



  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoForm } = this.state;
    const { tipo, pi_dt_producao, pi_dt_entrega, pis_status, pi_obs, checkDTProducao, checkDTEntrega, checkStatus, checkOBS } = this.state.registro;

    // console.log('MonitorProducaoForm.this.state: ', this.state);

    return (
      <Modal
        // title={tipo === 'DP' || tipo === 'DE' || tipo === 'TDP' ? "Alterar Data" : tipo === 'OBS' ? "Alterar Observação" : "Alterar Status"}
        title={tipo === 'DP' || tipo === 'DE' ? "Alterar Data" : tipo === 'OBS' ? "Alterar Observação" : tipo === 'GRUPO' ? "Alterar Dados em Grupo" : "Alterar Status"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={tipo === 'OBS' ? "30%" : "20%"}
        style={{ top: 10 }}
      >


        <Row>

          {tipo === 'DP' || tipo === 'GRUPO' ? (
            <Col xs={24} sm={24} style={{ marginTop: 0 }}>
              {tipo === 'GRUPO' ? (
                <div style={{ marginBottom: -20 }}>
                  <InputForm
                    type="checkbox"
                    id="checkDTProducao"
                    ref="checkDTProducao"
                    value={checkDTProducao}
                    onChange={this.onChange}
                  >
                    Data Produção
                  </InputForm>
                </div>
              ) : (
                <span>Data Produção</span>
              )}
              <InputForm
                type="date"
                id="pi_dt_producao"
                ref="pi_dt_producao"
                value={pi_dt_producao}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
                style={{ width: "100%" }}
                disabled={tipo !== 'GRUPO' ? false : !checkDTProducao}
              />
            </Col>

          ) : null}
          {tipo === 'DE' || tipo === 'GRUPO' ? (
            <Col xs={24} sm={24} style={{ marginTop: 0 }}>
              {tipo === 'GRUPO' ? (
                <div style={{ marginBottom: -20 }}>
                  <InputForm
                    type="checkbox"
                    id="checkDTEntrega"
                    ref="checkDTEntrega"
                    value={checkDTEntrega}
                    onChange={this.onChange}
                  >
                    Data Entrega
                  </InputForm>
                </div>
              ) : (
                <span>Data Entrega</span>
              )}
              <InputForm
                type="date"
                id="pi_dt_entrega"
                ref="pi_dt_entrega"
                value={pi_dt_entrega}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
                style={{ width: "100%" }}
                disabled={tipo !== 'GRUPO' ? false : !checkDTEntrega}
              />
            </Col>
          ) : null}
          {tipo === 'TDP' ? (
            <Col xs={24} sm={24} style={{ marginTop: 0 }}>
              <span>Nova Data Produção</span>
              <InputForm
                type="date"
                id="pi_dt_producao"
                ref="pi_dt_producao"
                value={pi_dt_producao}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}
          {tipo === 'ST' || tipo === 'GRUPO' ? (
            <Col xs={24} sm={24} style={{ marginTop: 0 }}>
              {tipo === 'GRUPO' ? (
                <div style={{ marginBottom: -20 }}>
                  <InputForm
                    type="checkbox"
                    id="checkStatus"
                    ref="checkStatus"
                    value={checkStatus}
                    onChange={this.onChange}
                  >
                    Status
                  </InputForm>
                </div>
              ) : (
                <span>Status</span>
              )}
              <InputForm
                type="select"
                id="pis_status"
                ref="pis_status"
                value={pis_status}
                placeholder="Status da Venda"
                onChange={this.onChange}
                data={this.state.statusSelect}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                disabled={tipo !== 'GRUPO' ? false : !checkStatus}
              />
            </Col>
          ) : null}
          {tipo === 'OBS' || tipo === 'GRUPO' ? (
            <Col xs={24} sm={24} style={{ marginTop: 0 }}>
              {tipo === 'GRUPO' ? (
                <div style={{ marginBottom: -20 }}>
                  <InputForm
                    type="checkbox"
                    id="checkOBS"
                    ref="checkOBS"
                    value={checkOBS}
                    onChange={this.onChange}
                  >
                    Observação
                  </InputForm>
                </div>
              ) : (
                <span>Observação</span>
              )}
              <InputForm
                id="pi_obs"
                ref="pi_obs"
                type="textarea"
                rows={5}
                maxLength={450}
                onChange={this.onChange}
                value={pi_obs}
                validator={value => Boolean(value)}
                disabled={tipo !== 'GRUPO' ? false : !checkOBS}
              />
            </Col>
          ) : null}

        </Row>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                  disabled={!this.state.registro.editar}
                >
                  Alterar
                </Button>
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MonitorProducaoForm.js